import { environment } from '../environment/environment';

export const sessionVariables = {
  apiUrl: `${environment.api}`,
  loginUrl: `${environment.api}/auth/login`,
  logoutUrl: `${environment.api}/session`,
  userUrl: `${environment.api}/users`,
};
